import axios from "axios";
import AppConstants from "../../constants/AppConstants";

const API = axios.create({ baseURL: AppConstants.baseURL });

///==========================getCampaign data==================================/////
export const getCampaignApi = async () => await API.get("/clicks/getcampaign");

///==========================addCampaignMasterData data===========================/////
export const addCampaignMasterDataApi = async (formData) =>
  await API.post("/clicks/addcampaign", formData);

///===========================updateCampaignMasterData ==========================/////
export const updateCampaignMasterDataApi = async (formData) =>
  await API.put("/clicks/updatecampaign", formData);

////====================== Unknown User Data Routes ====================//

///==========================getUnknownUserData data==================================/////
export const getUnknownUserDataApi = async () =>
  await API.get("/clicks/getunknownuser");

///==========================addunknownuserApi data===========================/////
export const addunknownuserApi = async (formData) =>
  await API.post("/clicks/addunknownuser", formData);

///===========================updateUnknownUserDataApi ==========================/////
export const updateUnknownUserDataApi = async (formData) =>
  await API.put("/clicks/updateunknownuser", formData);

////====================== Campaign Urls Data Routes ====================//

///==========================getCampUrls data==================================/////
export const getCampUrlsApi = async () => await API.get("/clicks/getcampurls");

///==========================addCampUrls data===========================/////
export const addCampUrlsApi = async (formData) =>
  await API.post("/clicks/addcampurls", formData);

///===========================updateCampUrlsApi ==========================/////
export const updateCampUrlsApi = async (formData) =>
  await API.put("/clicks/updatecampurls", formData);

///==========================getCodeType data==================================/////
export const getCodeTypeApi = async () => await API.get("/clicks/getcodetype");

export const updateCodeTypeApi = async (formData) =>
  await API.put("/clicks/updatecodetype", formData);

export const getCountriesExceptApi = async () => await API.get("/clicks/getcountriesexcept");
export const addCountriesExceptApi = async (formData) => await API.post("/clicks/addcountriesexcept", formData);
export const updateCountriesExceptApi = async (formData) => await API.put("/clicks/updatecountriesexcept", formData);

///==========================getSiteId data==================================/////
export const getSiteIdApi = async () => await API.get("/clicks/getsiteid");

export const getClicksReportDataApi = async (formData) =>
  await API.post("/clicks/clicksreport", formData);

export const getConversionReportDataApi = async (formData) =>
  await API.post("/clicks/getconveriosnreport", formData);

export const uploadCSVApi = async (formData) =>
  await API.post("/clicks/uploadcsv", formData);

export const uploadCampCSVApi = async (formData) =>
  await API.post("/clicks/uploadcampcsv", formData);

export const getPartnerDetailsApi = async () =>
  await API.get("/clicks/allpartnerdetail");

export const getPartnerresponseDataApi = async (formData) =>
  await API.post("/clicks/getpartnerresponse", formData);

export const getResponseMasterDataCSVApi = (data) =>
  API.post("/clicks/responsemastercsv", data);

export const getFilterData = (data) =>
  API.post("/clicks/getfilterresult", data);

export const getFilterDataCampaignApi = (data) =>
  API.post("/clicks/getcampgraphfilterdata", data);

export const getCampGraphResultApi = (data) =>
  API.post("/clicks/getcampgraphreport", data);

export const getCampaignTableDetailsApi = (data) =>
  API.post("/clicks/getcamptabledata", data);

export const getNetworkTableDetailsApi = (data) =>
  API.post("/clicks/getnetworktabledata", data);

//------------------------Performance Wise Report Routes------------------------//
export const performanceSitesDataApi = (data) =>
  API.post("/clicks/perfromsitefilterdata", data);

export const getPerformanceSitesGraphDataApi = (data) =>
  API.post("/clicks/getperformancegraphdata", data);

export const getSitesTableDetailsApi = (data) =>
  API.post("/clicks/getsitetabledata", data);

export const getCronLogsApi = async (data) =>
  await API.post("/clicks/getcampcronlogs", data);

// Cron Resolver Config
export const getCronResolverConfigsApi = () => API.get("/clicks/getcronconfigs");
export const addCronResolverConfigApi = (data) => API.post("/clicks/addcronconfig", data);
export const updateCronResolverConfigApi = (data) => API.put("/clicks/updatecronconfig", data);
export const deleteCronResolverConfigApi = (data) => API.post("/clicks/deletecronconfig", data);


export const getNewUrlsSummaryApi = async (data) => await API.post("/clicks/getnewurlssummary", data);
export const getNewUrlsRawApi = async (data) => await API.post("/clicks/getnewurlsraw", data);


export const getExcludedUrlsApi = async () => await API.get("/clicks/getexcludedurls");
export const addExcludedUrlApi = async (data) => await API.post("/clicks/addexcludedurl", data);
export const deleteExcludedUrlApi = async (data) => await API.post("/clicks/deleteexcludedurl", data);

export const getCollectionStatsApi = async (params) => await API.get("/clicks/collection-stats", { params });
export const getCollectionStatsHistoryApi = async (camp_id) => await API.get(`/clicks/collection-stats/history/${camp_id}`);
export const getCollectionStatsWarningsApi = async () => await API.get("/clicks/collection-stats/warnings");

